import Cookie from 'js-cookie';
import { isLocalDev } from '@mgo/core/src/environment';

export const setSession = (uuid, orderUuid) => {
  Cookie.set('coa', uuid, {
    expires: 0.5 / 24, // expire 30 minutes
    sameSite: 'strict',
    secure: !isLocalDev(window.location.origin),
  });
  if (orderUuid) {
    Cookie.set('coaOrderUuid', orderUuid, {
      expires: 0.5 / 24, // expire 30 minutes
      sameSite: 'strict',
      secure: !isLocalDev(window.location.origin),
    });
  }
};
export const getOrderUuidSession = () => {
  Cookie.get('coaOrderUuid');
};
export const getSession = () => {
  Cookie.get('coa');
};

export const deleteSession = () => {
  Cookie.remove('coa');
  Cookie.remove('coaOrderUuid');
};

export const deleteCoaComplete = () => {
  Cookie.remove('coa_complete');
};

export const resetAppState = () => {
  // delete prefil and informed delivery session variables
  [
    'myMovePrefillOptIn', 'myMoveChoicePrefillOptIn',
    'informedDeliveryEligible', 'informedDelivery',
    'extension', 'extensionSelected',
    'offersChoice', 'autofillChoice', 'amp_data', 'optInMailReminder',
  ].forEach((v) => {
    sessionStorage.removeItem(v);
  });
};
